export const builderImage = (pref, choices, style_code = null) => {
  if (
    style_code ||
    (pref &&
      pref != "" &&
      choices[pref] &&
      choices[pref].value &&
      choices[pref].value != "")
  ) {
    let params = new URLSearchParams()
    style_code = style_code || choices[pref].value

    params.append("dim", "128")
    params.append("image_format", "png")
    const choiceKeys = Object.keys(choices)
    for (var i = 0; i < choiceKeys.length; i++) {
      const choiceKey = choiceKeys[i]
      if (
        choiceKey.split("_")[0] == pref &&
        choiceKey != pref &&
        choices[choiceKey]
      ) {
        params.append(
          choiceKey.replace(pref + "_", ""),
          choices[choiceKey].value
        )
      }
    }
    const url = `${
      window.sl.config.full_main_render_url
    }${style_code}?${params.toString()}`
    return url.toString()
  } else {
    return require("images/icons/jewlr.gif")
  }
}
